/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import Header from "./Header"

const Layout = ({ children }) => {
  return (
    <>
      {/* <Header /> */}
      <div className="antialiased font-body">
        <main>{children}</main>
        <footer className="flex flex-col items-center py-12 space-y-8 text-center bg-gray-100">
          <div className="flex items-center space-x-8">
            <a
              className="w-8 h-8 text-gray-700 transition-colors duration-200 hover:text-gray-900"
              href="https://www.linkedin.com/in/danstowell/"
              target="_blank"
              aria-label="LinkedIn"
              rel="noopener noreferrer"
            >
              <svg
                role="img"
                aria-hidden="true"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill="currentColor"
                  d="M19.7,3H4.3C3.582,3,3,3.582,3,4.3v15.4C3,20.418,3.582,21,4.3,21h15.4c0.718,0,1.3-0.582,1.3-1.3V4.3 C21,3.582,20.418,3,19.7,3z M8.339,18.338H5.667v-8.59h2.672V18.338z M7.004,8.574c-0.857,0-1.549-0.694-1.549-1.548 c0-0.855,0.691-1.548,1.549-1.548c0.854,0,1.547,0.694,1.547,1.548C8.551,7.881,7.858,8.574,7.004,8.574z M18.339,18.338h-2.669 v-4.177c0-0.996-0.017-2.278-1.387-2.278c-1.389,0-1.601,1.086-1.601,2.206v4.249h-2.667v-8.59h2.559v1.174h0.037 c0.356-0.675,1.227-1.387,2.526-1.387c2.703,0,3.203,1.779,3.203,4.092V18.338z"
                ></path>
              </svg>
            </a>
          </div>

          <p className="max-w-screen-md px-6 text-gray-700">
            SAT® is a registered trademark of the College Entrance Examination
            Board™. ACT® is a registered trademark of the ACT Incorporated™.
            Neither the College Entrance Examination Board™ nor ACT
            Incorporated™ endorse, or are affiliated in any way, with the owner
            or any content of this web site.
          </p>
          <div className="text-gray-700">© 2026 How To Literally</div>
        </footer>
      </div>
    </>
  )
}

export default Layout
